import { sendData, getData } from "./../../misc/server.js";
export default {
  state: {
    data: [],
    loading: false,
  },
  mutations: {
    SET_DATA(state, payload) {
      state.data = payload;
    },
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
  },
  actions: {
    async getExercise({ commit }, payload) {
      var url = `exercise/get?subject_id=${payload.subject_id}&class_id=${payload.class_id}&`;

      commit("SET_LOADING", true);
      var response = await getData(url);

      commit("SET_DATA", response.data);
      commit("SET_LOADING", false);
    },
    async getEachExercise({ commit }, payload) {
        var url = `exercise/getEach?id=${payload.id}&`;
  
        commit("SET_LOADING", true);
        var response = await getData(url);
        
        commit("SET_DATA", response.data);
        commit("SET_LOADING", false);
      },
    
  },
  getters: {
    exercises(state) {
      return state.data;
    },
    exercise_loading(state) {
      return state.loading;
    },
  },
};
